const BASE_URL = process.env.REACT_APP_BASE_URL;


export async function createQueue(queueInfo) {
  const customerName = queueInfo.customerName;
  const queueName = queueInfo.queueName;

 
  const queue_url = `${BASE_URL}/azure_queue_proxy?storage_account=${customerName}&report_channel_name=${queueName}`;
 

  const queue_headers = {
    "x-report-channel-type": process.env.REACT_APP_REPORT_CHANNEL_TYPE,
    Authorization: `Bearer ${queueInfo.accessToken}`,
    "X-User-ID": sessionStorage.getItem("UserID") || "",
  };

  
  

  let queueResponse = null;
  try {
    queueResponse = await fetch(queue_url, {
      method: "POST",
      headers: queue_headers,
    });
  } catch (error) {
    let errMsg = `Error sending create queue request for '${customerName}/${queueName}': status:${queueResponse.status} message:${queueResponse.message}`;
    
    
    new Error(errMsg);
  }

  if (!queueResponse.ok) {
    let contentType = queueResponse.headers.get("Content-Type");
    let errorMsg = "";
    if (contentType && contentType.includes("application/json")) {
      errorMsg = (await queueResponse.json()).message;
    } else {
      errorMsg = queueResponse.statusText;
    }
    let errMsg = `createQueue:Error creating queue '${customerName}/${queueName}': status:${queueResponse.status} message:${errorMsg}`;
    
    
    throw new Error(errMsg);
  }

  
}

export async function deleteQueue(queueInfo) {
  if (queueInfo == null) {
   
    return;
  }

  const url = `${BASE_URL}/azure_queue_proxy?storage_account=${queueInfo.customerName}&report_channel_name=${queueInfo.queueName}`;
  const headers = {
    "x-report-channel-type": process.env.REACT_APP_REPORT_CHANNEL_TYPE,
    Authorization: `Bearer ${queueInfo.accessToken}`,
    "X-User-ID": sessionStorage.getItem("UserID") || "",
  };

  
  

  try {
    const response = await fetch(url, {
      method: "DELETE",
      headers,
    });

    if (!response.ok) {
      let contentType = response.headers.get("Content-Type");
      let errorMsg = "";
      if (contentType && contentType.includes("application/json")) {
        errorMsg = (await response.json()).message;
      } else {
        errorMsg = response.statusText;
      }
      let msg = `Failed to delete queue '${queueInfo.customerName}/${queueInfo.queueName}': ${errorMsg}`;
      throw new Error(msg);
    }

    let msg = `Queue '${queueInfo.storage_account}/${queueInfo.queueName}'deleted successfully.`;

  } catch (err) {
    
  }
}


export async function displayLog(
  queueInfo,
  setLog,
  setTimeseriesFile,
  setEconomicSummaryFile,
  setDailySummaryFile,
  setSimulationFailureMessage,
  { cancelToken = { cancelled: false }, handleButtonClick } = {},
) {
  
  

  const url = `${BASE_URL}/azure_queue_proxy?storage_account=${queueInfo.customerName}&report_channel_name=${queueInfo.queueName}`;
  const headers = {
    "x-report-channel-type": process.env.REACT_APP_REPORT_CHANNEL_TYPE,
    Authorization: `Bearer ${queueInfo.accessToken}`,
    "X-User-ID": sessionStorage.getItem("UserID") || "",
  };

  let finalMessageProcessed = false;
  const seenLogs = new Set(); // Track displayed messages

  while (!finalMessageProcessed) {
    // Allow the caller to stop polling (e.g. when the simulate request
    // failed before any final message was written to the queue).
    if (cancelToken.cancelled) {
      return;
    }

    const response = await fetch(url, { method: "GET", headers });

    if (!response.ok) {
      let contentType = response.headers.get("Content-Type");
      let errorMsg = "";
      if (contentType && contentType.includes("application/json")) {
        errorMsg = (await response.json()).message;
      } else {
        errorMsg = response.statusText;
      }
      let msg = `Failed to fetch log from '${queueInfo.customerName}/${queueInfo.queueName}': ${errorMsg}`;
      
      
      setSimulationFailureMessage(msg);
      throw new Error(msg);
    }

    const logData = await response.json();
    if (logData.message) {
      const logMessages = logData.message.split("\n");
      for (const msg of logMessages) {
        if (!seenLogs.has(msg)) {
          seenLogs.add(msg);
          setLog((prevLog) => `${prevLog}\n${msg}`);
        }

        if (isFinalLogMessage(msg)) {
          const parsedMessage = JSON.parse(msg);
          finalMessageProcessed = true;

          if (parsedMessage.code === 200) {
            setSimulationFailureMessage("");
            setTimeseriesFile(parsedMessage.dataset_names_array[0]);
            setEconomicSummaryFile(parsedMessage.dataset_names_array[1]);
            setDailySummaryFile(parsedMessage.dataset_names_array[1]);
            if (handleButtonClick) {
              handleButtonClick(parsedMessage.dataset_names_array[0]);
            }
            break;
          } else {
            let msg = `Log from queue returned error: code: ${parsedMessage.code}: ${parsedMessage.message}`;
            setSimulationFailureMessage(msg);
            throw new Error(parsedMessage.message);
          }
        }
      }
    }

    if (!finalMessageProcessed) {
      await new Promise((resolve) => setTimeout(resolve, 1000));
    }
  }
}

const isFinalLogMessage = (line) => {
  try {
    const json = JSON.parse(line);
    return json && typeof json === "object";
  } catch (e) {
    return false;
  }
}
